import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private readonly ACCESS_TOKEN_KEY = 'access_token';
  private readonly REFRESH_TOKEN_KEY = 'refresh_token';
  private readonly storage: Storage | null;

  constructor() {
    this.storage = typeof window !== 'undefined' ? window.localStorage : null;
  }

  setAccessToken(token: string): void {
    if (token !== undefined) {
      this.storage?.setItem(this.ACCESS_TOKEN_KEY, token);
    }
  }

  setRefreshToken(token: string): void {
    if (token !== undefined) {
      this.storage?.setItem(this.REFRESH_TOKEN_KEY, token);
    }
  }

  setTokens(accessToken: string, refreshToken: string): void {
    if (accessToken !== undefined) {
      this.setAccessToken(accessToken);
    }
    if (refreshToken !== undefined) {
      this.setRefreshToken(refreshToken);
    }
  }

  getAccessToken(): string | null {
    return this.storage?.getItem(this.ACCESS_TOKEN_KEY) ?? null;
  }

  getRefreshToken(): string | null {
    return this.storage?.getItem(this.REFRESH_TOKEN_KEY) ?? null;
  }

  removeAccessToken(): void {
    this.storage?.removeItem(this.ACCESS_TOKEN_KEY);
  }

  removeRefreshToken(): void {
    this.storage?.removeItem(this.REFRESH_TOKEN_KEY);
  }

  removeTokens(): void {
    this.removeAccessToken();
    this.removeRefreshToken();
  }

  hasAccessToken(): boolean {
    return !!this.getAccessToken();
  }

  hasRefreshToken(): boolean {
    return !!this.getRefreshToken();
  }

  hasTokens(): boolean {
    return this.hasAccessToken() && this.hasRefreshToken();
  }

  isAccessTokenExpired(): boolean {
    const token = this.getAccessToken();
    if (!token) return true;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.exp * 1000 < Date.now();
    } catch {
      return true;
    }
  }
}
